import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from '@greenkub-fronts/store';
import { Injector } from './injector';
import App from './app/app';
import { ErrorBoundaryMain } from '@greenkub-fronts/shared/ui';
import { PostHogProvider } from 'posthog-js/react';
import TagManager from 'react-gtm-module';
import { ConfigProvider } from 'antd';

const options = {
  api_host: import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_HOST,
};

const root = ReactDOM.createRoot(
  (document.getElementById('app-root') as HTMLElement) ||
  document.createElement('div'),
);

const gtmId = import.meta.env.VITE_GTM_ID;
if (gtmId) {
  TagManager.initialize({ gtmId });
}

store.initReduxStore(Injector.getDependencies());

const isDevelopment = import.meta.env.MODE === 'development' || import.meta.env.DEV;
const posthogKey = import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_KEY;

const AppContent = (
  <Provider store={store.getStore()}>
    <BrowserRouter>
      <ErrorBoundaryMain>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#41B883',
              colorPrimaryBorder: '#41B883',
              colorPrimaryHover: '#41B883',
              colorError: '#ff4d4f',
            },
          }}
        >
          <App />
        </ConfigProvider>
      </ErrorBoundaryMain>
    </BrowserRouter>
  </Provider>
);

root.render(
  isDevelopment || !posthogKey ? (
    AppContent
  ) : (
    <PostHogProvider apiKey={posthogKey} options={options}>
      {AppContent}
    </PostHogProvider>
  ),
);
